import type { FC } from 'react';
import { Picture } from '@ui';
import icons from '@icons';

const {
  pin: { black: pinFilledBlack }
} = icons.Fill;
const {
  list: { black: listBlackOutlined }
} = icons.Outline;

interface MapToggleProps {
  isOpenMap: boolean;
  onChange: (isOpenMap: boolean) => void;
}

const MapToggle: FC<MapToggleProps> = ({ isOpenMap, onChange }) => (
  <div className='changerMapControl'>
    <div
      className='changerMapControl__friend'
      onClick={() => {
        onChange(false);
      }}
    >
      <Picture className='icon' icon={listBlackOutlined} height='14' alt='' />
      Адрес
    </div>
    <div
      className='changerMapControl__self'
      onClick={() => {
        onChange(true);
      }}
    >
      <Picture className='icon' icon={pinFilledBlack} height='14' alt='' />
      На карте
    </div>
    <div
      className={`changerMapControl__bg-slide${
        isOpenMap ? ' changerMapControl__bg-slide--right' : ''
      }`}
    />
  </div>
);

export default MapToggle;
